import { FC, JSX } from "react";
import {
  View,
  Text,
  TouchableOpacity
} from "react-native";
import ArrowRight from "@/assets/icons/main/arrowRight.svg";
import { useRouter } from "expo-router";
import { useAppDispatch } from "@/_hooks";
import { setReportId } from "@/_reducers/reportId.reducer";

interface IRecentActivityBlockProps {
  companyName: string;
  lastReportDate: string;
  isFiz: boolean;
  reportId: string;
}

const RecentActivityBlock: FC<IRecentActivityBlockProps> = ({
  companyName,
  lastReportDate,
  isFiz,
  reportId
}): JSX.Element => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleReport = (): void  => {
    dispatch(setReportId(reportId));

    if (isFiz && reportId){
      router.push(`/general/successUserCheck?id=${reportId}`)
    }
  }

  return (
    <TouchableOpacity
      onPress={handleReport}
      className="flex-row justify-between items-center border border-gray-400 text-border rounded-3xl p-5 mb-2"
    >
      <View className="flex-1 flex-col gap-1">
        <Text
          className="text-black text-lg"
          numberOfLines={2}
          ellipsizeMode="tail"
        >
          {companyName || "Информация отсутствует"}
        </Text>
        <Text className="text-sm text-gray">{lastReportDate}</Text>
      </View>
      <View>
        <ArrowRight/>
      </View>
    </TouchableOpacity>
  );
};

export default RecentActivityBlock;
